module.exports = __webpack_public_path__ + "img/logo-twitter.e8be5b26.svg";